import type { KatalogAttribut } from '../gql/graphql.ts';
import { Checkbox } from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import { InfoPopover, type PopoverSeite } from './InfoPopover.tsx';

type AttributProps = {
  attribut: KatalogAttribut;
  gewaehlt: boolean;
  infoSeite: PopoverSeite;
  onToggle: () => void;
};

export function Attribut({
  attribut,
  gewaehlt,
  infoSeite,
  onToggle,
}: AttributProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2">
      <Checkbox checked={gewaehlt} onCheckedChange={onToggle} />
      <span className="text-sm text-neutrals-900">{attribut.name}</span>
      <span className="text-xs text-neutrals-700">{attribut.typ}</span>
      {attribut.beschreibung !== '' && (
        <InfoPopover
          seite={infoSeite}
          text={attribut.beschreibung}
          label={t('domain.e2nApi.neuerZugang.attributInfo', {
            attribut: attribut.name,
          })}
        />
      )}
    </div>
  );
}
